import styled from "styled-components";

export const StyledQuestionPreviewBox = styled.div`
  padding: 0;
  direction: rtl;
  width: 100%;

  .question-card-container {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 4px 10px 0px #7e8aad40;
    width: 100%;
  }

  .question-card {
    background: linear-gradient(271.58deg, #004EF7 0%, #00EAB2 96.51%);
    padding: 11px 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60px;
    box-sizing: border-box;
  }

  .question-content {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.22px;
    text-align: center;
    vertical-align: middle;
    color: #ffffff;
    word-break: break-word;
  }

  .question-note {
    background: #f7f8fa;
    padding: 25px 20px;
    color: #122243;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: -0.22px;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    width: 100%;
  }

  .footer-wrapper {
    padding-top: 60px;
    background: transparent;
    width: 100%;
    margin-top: auto;
    padding-bottom: 20px;
  }

  .question-footer {
    background: #ffffffcc;
    padding: 24px 20px 12px;
    color: #122243;
    font-family: "Google Sans", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.22px;
    text-align: center;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    border-radius: 10px;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 12px;
      background: #004ef7;
    }
  }
`;
